import React from 'react';
import { Paper, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Collapse from '@material-ui/core/Collapse';

const useStyles = makeStyles(theme => ({
  container: {
    minWidth: '20rem',
    backgroundColor: theme.palette.background.default,
  },
  body: {
    width: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginLeft: 'calc(100vw - 100%)',
  },
  bodycontent: {
    margin: 'auto',
    maxWidth: '68.5rem',
    display: 'flex',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  goBackButton: {
    borderRadius: '0.25rem',
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    '&:focus': {
      color: theme.palette.primary.main,
    },
  },
  text: {
    paddingLeft: '0.8rem',
  },
}));

const GoBackBar = ({
  isHidden, buttontext, handleClick,
}) => {
  const classes = useStyles();
  return (
    <Collapse in={!isHidden}>
      <Paper elevation={0} className={classes.container}>
        <div className={classes.body}>
          <div className={classes.bodycontent}>
            <ButtonBase
              tabIndex={!isHidden ? 0 : -1}
              focusRipple
              onClick={handleClick}
              className={classes.goBackButton}
            >
              <ArrowBack />
              <Typography className={classes.text} color="inherit" variant="body1">
                { buttontext }
              </Typography>
            </ButtonBase>
          </div>
        </div>
      </Paper>
    </Collapse>
  );
};

GoBackBar.propTypes = {
  /** Location from props */
  isHidden: PropTypes.bool,
  /** Text to display on button */
  buttontext: PropTypes.any,
  /** Click event handler */
  handleClick: PropTypes.func,
};

GoBackBar.defaultProps = {
  buttontext: 'Gå tilbake',
  isHidden: false,
  handleClick: () => {},
};

export default GoBackBar;
